// Remove 'cell-tick' class - added in 'avast.js'
$(document).ready(function(){
	$('.feature--item td').removeClass('cell-tick');
});